import React from 'react';

const ProptechServicesPage = () => {

    return (
        <>
            <iframe src="https://proptech-services-page.netlify.app/" style={{ width: '100%', height: '100vh', border: 'none' }}></iframe>
        </>
    );
};

export default ProptechServicesPage;